import React, { useEffect } from "react";
import aboutUs from "../../assets/contact/bg style.png";
import aboutUs2 from "../../assets/contact/Landscape 5.JPG";
import goals from "../../assets/contact/Group 194 (1).png";
import romantic from "../../assets/contact/Illustration (1).png";
import goals2 from "../../assets/contact/image 919.png";
import aboutStyle from "./about.module.css";
import ReviewsSlider from "../sections/reviewsSlider/reviewsSlider";
import { useTranslation } from "react-i18next";

export default function About() {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = "About Us - Regency Plaza Aqua Park";
  }, []);

  return (
    <>
      {/* Banner Section */}
      <section className={`${aboutStyle.bannerBg}`}>
        <div
          className={`d-flex justify-content-center align-items-center ${aboutStyle.bannerBgColor}`}
        >
          <div className="text-center px-4 px-md-5">
            <div className="layer rounded-5 p-3 fade-in-animation">
              <h1 className="BigshotOneFont text-white fs-5 fs-md-7 pt-5 mt-5 pt-md-0 mt-md-0">
                {t("about_us_page.about_us")}
              </h1>
              <p className="text-white fs-6">
{t("about_us_page.welcome_message")}              </p>
            </div>
          </div>
        </div>
      </section>

      {/* About Us Section */}
<section className="container my-5 py-5">
  <div className="row align-items-center justify-content-between">
    {/* Image Side */}
    <div className="col-12 col-md-6 mb-4 mb-md-0">
      <div className="position-relative">
        <img
          src={aboutUs}
          alt="Decorative element"
          className="position-absolute top-0 start-0 w-75 opacity-25 d-none d-md-block"
          style={{ zIndex: 0 }}
        />
        <img
          src={aboutUs2}
          alt="Resort Overview"
          className="w-100 rounded-5 shadow-lg position-relative"
          style={{ zIndex: 1 }}
        />
      </div>
    </div>

    {/* Text Content Side */}
    <div className="col-12 col-md-6 px-4 px-md-5">
      <h2 className="BigshotOneFont textPrimaryColor mb-4">
        {t("about_us_page.about_us")}
      </h2>

      <ul className="list-unstyled fs-6 lh-lg">
        <li className="mb-3">
          • {t("about_us_page.about_resort")}
        </li>
        <li className="mb-3">
          • {t("about_us_page.about_royal")}
        </li>
        <li className="mb-3">
          • {t("about_us_page.about_romance")}
        </li>
      </ul>

      <p className="mt-3">
        {t("about_us_page.about_conclusion")}
      </p>
    </div>
  </div>
</section>

      {/* Wanderlust Section */}
      <section className={`${aboutStyle.wanderlustBg}`}>
        <div
          className={`d-flex justify-content-center align-items-center h-100 ${aboutStyle.overLay}`}
        >
          <div className="text-center pt-5">
            <h1 className="BigshotOneFont text-white">
              {t("about_us_page.wanderlust")}
            </h1>
          </div>
        </div>
      </section>

      {/* Goals Section */}
      <section className="container my-5">
  <div className="row align-items-center justify-content-center position-relative">
    <div className="col-12 col-md-6 text-center mb-4 mb-md-0">
      <img src={goals} className="w-100" alt="Goals Illustration" />
    </div>
    <div className="col-12 col-md-6 position-relative px-4 px-md-5">
      <h2 className="BigshotOneFont fs-4 fs-md-3 mb-4">
        {t("about_us_page.goals_title")}
      </h2>
      <div className="mb-4">
        <h5 className="fw-bold text-primary">{t("about_us_page.goals.title")}</h5>
        <ul className="list-unstyled ps-3">
        {t("about_us_page.goals.items", { returnObjects: true }).map((item, idx) => (
            <li key={idx}>• {item}</li>
          ))}
        </ul>
      </div>
      <div>
        <h5 className="fw-bold text-primary">{t("about_us_page.plans.title")}</h5>
        <ul className="list-unstyled ps-3">
        {t("about_us_page.plans.items", { returnObjects: true }).map((item, idx) => (
            <li key={idx}>• {item}</li>
          ))}
        </ul>
      </div>
    </div>
  </div>
</section>

      {/* Romantic Destinations Section */}
      <section className="container my-5">
        <div className="row align-items-center justify-content-center">
          <div className="col-12 col-md-6 order-first order-md-3 text-center">
            <img src={romantic} className="w-100" alt="" />
          </div>
          <div className="col-12 col-md-6 px-4 px-md-5">
            <h2 className="BigshotOneFont h3">
              {t("about_us_page-me.romantic_destinations_title")}
            </h2>
            <p>

            {t("about_us_page-me.romantic_destinations_description")}
            </p>

          </div>
        </div>
      </section>

      {/* Reviews Slider */}
      <ReviewsSlider />
    </>
  );
}
